import {Component, OnInit, Input, ViewChild} from '@angular/core';
import { Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { Configuration, ClearMultiVinErrors } from 'remarketing-angular-library';
import { Subject } from 'rxjs';
import {
  MultiVinErrorModalComponent
} from '../../../../../shared/ui/modals/multi-vin-error-modal/multi-vin-error-modal.component';
import { TranslocoDirective } from '@jsverse/transloco';


@Component({
    selector: 'lib-multi-vin-error',
    templateUrl: './multi-vin-error.component.html',
    styleUrls: ['./multi-vin-error.component.scss'],
    imports: [TranslocoDirective, MultiVinErrorModalComponent]
})
export class MultiVinErrorComponent implements OnInit {
  @ViewChild(MultiVinErrorModalComponent) multiVinErrorModal: MultiVinErrorModalComponent;
  @Input() vins: string[];
  @Input() stockNumbers: string[];
  configuration: Configuration;
  private destroyed$ = new Subject();

  constructor(private readonly store: Store) {}

  get type() {
    if (this.vins && this.vins.length) {
      return 'VIN';
    }

    if (this.stockNumbers && this.stockNumbers.length) {
      return 'STOCK';
    }

    return null;
  }

  get missingItems() {
    if (this.vins && this.vins.length) {
      return this.vins;
    }

    if (this.stockNumbers && this.stockNumbers.length) {
      return this.stockNumbers;
    }

    return null;
  }

  ngOnInit() {
    this.store
      .select(_state => _state.configuration.configuration)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(_configuration => (this.configuration = _configuration));
  }

  closeError() {
    // clear the error and multi vin data in the search state
    this.store.dispatch(new ClearMultiVinErrors());
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  showModal() {
    this.multiVinErrorModal.show();
  }
}
